import * as React from "react"
export const IconIncludeText = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <path strokeWidth="0"
            d="M9.5 9.5V11C9.5 11.4156 9.16562 11.75 8.75 11.75C8.33437 11.75 8 11.4156 8 11V9.25C8 8.55937 8.55937 8 9.25 8H20.75C21.4406 8 22 8.55937 22 9.25V11C22 11.4156 21.6656 11.75 21.25 11.75C20.8344 11.75 20.5 11.4156 20.5 11V9.5H15.75V20.5H17.25C17.6656 20.5 18 20.8344 18 21.25C18 21.6656 17.6656 22 17.25 22H12.75C12.3344 22 12 21.6656 12 21.25C12 20.8344 12.3344 20.5 12.75 20.5H14.25V9.5H9.5Z" />
    </svg>
}
export default IconIncludeText;